import { useAdditionalFee } from "@/components/features/items/edit/hotel-policy/_shared/components/main/question/additional-fee/hooks";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationAdditionalFee = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { additionalFees } = viewModel;

	return useAdditionalFee({ additionalFees, onSetViewModel });
};
